import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "crm-notarile-main-container" }
const _hoisted_2 = {
  key: 0,
  class: "crm:mt-6"
}
const _hoisted_3 = {
  key: 0,
  class: "crm:flex crm:items-center crm:mb-2"
}
const _hoisted_4 = { class: "crm:mb-2 crm:lg:mb-0" }
const _hoisted_5 = { class: "crm:flex crm:content-start crm:flex-col crm:lg:flex-row crm:mt-2" }
const _hoisted_6 = { class: "crm:font-extrabold! crm:text-2xl!" }
const _hoisted_7 = ["innerHTML"]

import {ref, provide, inject, watch, onMounted} from "vue";
import AppUserProfilePopover from "../components/AppUserProfilePopover.vue";
import BaseBreadcrumbs from '../components/BaseBreadcrumbs.vue';
import TheEmergencyBanner from "../components/TheEmergencyBanner.vue";
import TheMainSidebar from "../components/TheMainSidebar.vue";
import TheNavbarTop from "../components/TheNavbarTop.vue";
import {useRoute} from "vue-router";
import {usePraticaStore} from "../store/crm.store";
import {useNavigation} from './useNavigation'


export default {
  __name: 'TheNotaioLayout',
  props: {
  /**
   * Dati inerenti l'utente connesso
   */
  dati: {
    type: [Object, Array],
    default() {
      return {}
    }
  },
  /**
   * Informazioni di intestazione (contiene anche i dati per comporre il breadcrumb)
   */
  intestazione: {
    type: Object,
    default() {
      return {}
    }
  }
},
  setup(__props) {

/**
 * @doc
 * Gestisce la renderizzazione e la comunicazione tra i componenti uguali per tutte le pagine
 * Attualmente è l'unico layout disponibile.
 * Ma inizialmente (ancora in sospeso la decisione) si ipotizzava di avere un template differente per notaio e uno per cliente.
 */
const props = __props

const is_sidebar_open = ref(true)

/**
 * @inject {isMobile} recupera il valore se siamo nella modalità mobile oppure no
 */
const isMobile = inject('isMobile')

/*const sidebar_navigation_cittadino = sidebarNavigationCittadino;
const sidebar_navigation_notaio = sidebarNavigationNotaio;*/

const sidebar_navigation = ref(useNavigation(props.dati.is_notaio, props.dati.features));

const sidebar_navigation_mobile = useNavigation(props.dati.is_notaio, props.dati.features, 'mobile');

const route = useRoute();
const isShowSidebar = ref(false)

watch(isMobile, (newValue) => {
  isShowSidebar.value = !newValue;

  if(newValue) {
    sidebar_navigation.value =  {... sidebar_navigation.value, ...sidebar_navigation_mobile};
  } else {
    Object.keys(sidebar_navigation.value).forEach((sidebarKey) => {
      if(sidebar_navigation_mobile[sidebarKey] !== undefined) {
        delete sidebar_navigation.value[sidebarKey]
      }
    })
  }
}, {immediate: true})

/**
 *
 * @param status
 */
const toggleSidebarOpen = (status) => {
  isShowSidebar.value = status
  if(status) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }
}

/**
 *
 * @param status
 */
const checkSidebar = (status) => is_sidebar_open.value = status;

const isShowUser = ref(false)
const praticaStore = usePraticaStore();

/**
 * Controlla che il path nell'url combaci con un elemento della navigazione
 * Se trova un riferimento lo attiva.
 * @method checkNavigationPath
 * @public checkNavigationPath
 */
function checkNavigationPath() {
  Object.keys(sidebar_navigation.value).forEach((itemNavKey) => {
    if (sidebar_navigation.value[itemNavKey].urlMap === route.name) {
      sidebar_navigation.value[itemNavKey]['is_active'] = true;
    } else if (sidebar_navigation.value[itemNavKey]['subPath'].length > 0 && sidebar_navigation.value[itemNavKey]['subPath'].includes(route.name)) {
      sidebar_navigation.value[itemNavKey]['is_active'] = true;
    } else if (sidebar_navigation.value[itemNavKey]['children'] !== undefined) {
      (sidebar_navigation.value[itemNavKey].children).forEach((child) => {
        if(child.urlMap === route.name) {
          sidebar_navigation.value[itemNavKey]['isExpand'] = true
          child['is_active'] = true;
        }
      })
    }
  })
}

onMounted(() => {
  praticaStore.tipoUtenteConnesso = (props.dati.is_cittadino) ? 'cittadino' : 'notaio'
  praticaStore.nomeUtenteConnesso = props.dati.nome_utente

  setTimeout(() => {
    isShowUser.value = true;
    if (route) {
      checkNavigationPath();
    }
  }, 100)
})

/**
 * @provides {isShowSidebar} se true mostra la sidebar (nel desktop è sempre a true, il toggle è usato nel mobile)
 */
provide('isShowSidebar', isShowSidebar)

/**
 * @provides {toggleSidebarOpen} toggle usato nel mobile per mostrare/nascondere la sidebar laterale
 */
provide('toggleSidebarOpen', toggleSidebarOpen)

const isNewsBannerShow = ref(!props.dati.is_cittadino)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(TheNavbarTop, {
        mainname: __props.dati.mainname,
        nome_utente: __props.dati.nome_utente,
        privacy: __props.dati.privacy,
        is_notaio: __props.dati.is_notaio,
        is_logged_in: __props.dati.is_logged_in,
        logo: __props.dati.logo,
        features: __props.dati.features,
        onIsShowSidebar: toggleSidebarOpen
      }, {
        default: _withCtx(() => [
          (_unref(isMobile))
            ? (_openBlock(), _createBlock(AppUserProfilePopover, {
                key: 0,
                is_sidebar_open: is_sidebar_open.value,
                "dati-utente": __props.dati,
                class: "crm:ml-4"
              }, null, 8 /* PROPS */, ["is_sidebar_open", "dati-utente"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["mainname", "nome_utente", "privacy", "is_notaio", "is_logged_in", "logo", "features"])
    ]),
    (isShowSidebar.value)
      ? (_openBlock(), _createBlock(TheMainSidebar, {
          key: 0,
          mainname: __props.dati.mainname,
          "nome-utente": __props.dati.nome_utente,
          dati: __props.dati,
          class: _normalizeClass({'crm:z-40 crm:mt-10': !_unref(isMobile), 'crm:z-50':_unref(isMobile)}),
          navigation: sidebar_navigation.value,
          "onSidebar:toggle": checkSidebar
        }, {
          default: _withCtx(({is_sidebar_open_slot}) => [
            (!_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(AppUserProfilePopover, {
                    is_sidebar_open: is_sidebar_open_slot,
                    "dati-utente": __props.dati
                  }, null, 8 /* PROPS */, ["is_sidebar_open", "dati-utente"])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["mainname", "nome-utente", "dati", "class", "navigation"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(["crm:bg-zinc-100 crm:min-h-[calc(100vh-70px)] crm:p-4 crm:mt-4 crm:transition-all crm:ease-out", {'crm:ml-52': is_sidebar_open.value && !_unref(isMobile), 'crm:ml-20': !is_sidebar_open.value & !_unref(isMobile)}])
    }, [
      (__props.intestazione)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(BaseBreadcrumbs, {
                path: __props.intestazione.path,
                "current-page": __props.intestazione.currentPage
              }, null, 8 /* PROPS */, ["path", "current-page"]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", _hoisted_6, [
                  _createElementVNode("span", {
                    innerHTML: __props.intestazione.title
                  }, null, 8 /* PROPS */, _hoisted_7),
                  _createTextVNode(_toDisplayString(__props.intestazione.descrizione ? ' (' + __props.intestazione.descrizione + ')' : ''), 1 /* TEXT */)
                ]),
                _createCommentVNode("@slot permette di inserire una toolbar affianco al titolo "),
                _renderSlot(_ctx.$slots, "intestazione-toolbar")
              ]),
              _createCommentVNode("@slot permette di inserire un sottotitolo "),
              _renderSlot(_ctx.$slots, "intestazione-sottotitolo")
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" @slot viene renderizzato il componente della pagina corrispondente "),
      _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */),
    _createCommentVNode("<the-news-banner v-model:is_show=\"isNewsBannerShow\" id=\"equo_compenso\"/>"),
    _createVNode(TheEmergencyBanner)
  ]))
}
}

}